module.exports = __webpack_public_path__ + "static/media/p.f7701c32.svg";